const publicRoutes = [
  '/login',
  '/signup',
  '/resetpassword',
  '/setpassword',
  '/',
  '/impressum',
  '/forgotpassword',
  '/forgotpassword-oevs',
  '/accountactivated',
  '/activationfailed',
  '/benutzerregistrierung',
  '/externallogin',
  '/signup-oevs',
  '/login-oevs',
];

export default publicRoutes;



// WEBPACK FOOTER //
// ./src/app/util/publicRoutes.js